module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("CHAPTER ONE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cop, ain’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a funny edge to his voice. Funny as in tragic. Out of politeness I ignored this first impression and told myself, here is just some guy in the park curious to know if he has me rightly pegged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was short and moonfaced, somewhere past sixty years and too heavy by about twenty pounds. His eyes were brown and magnified by thick spectacles in round, wire frames. His pale pink face was arranged in a careful blank, his chin napped with a goatee that was a mix of red and gray. He wore a shapeless pair of twill pants, worn-out suede shoes, a thrift-shop sport coat over a faded denim shirt, and a navy woolen beret on top of what I guessed was a bald head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He perspired despite the cool April air. Two thin lines of sweat trickled down from someplace up under his beret, down over the front of his ears and then forward along the edges of his jaw until droplets vanished in his whiskers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifteen minutes ago, when I walked into the park with my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times")]), _vm._v(" and a buttered roll and coffee from the deli, I had casually noticed this guy and how it was just the two of us "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v(" there in the little park in the middle of a weekday morning. I had my own concerns. He certainly had his.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I had sat down on one of the only two functional benches left in the park. This was the bench in the sun. He was already settled on the other one, across a walkway filled with broken brick and glass, in the faint shade of city trees sprouting new leaves. I noted that he had one of those supermarket tabloids spread open across his knees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A couple of times when I turned a page or took a sip of coffee, I happened to glance over his way. And I had caught him looking at me instead of at the paper in his lap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now, here he was on his feet in front of me, close enough so I could hear his raspy breathing. Here he was, curious in a funny way. As in not funny, actually.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at my wristwatch: half-past ten. I also looked at the block-letter streamer on the cover of his tabloid: "), _c('span', {
    staticClass: "small"
  }, [_vm._v("STATUE OF ELVIS FOUND ON MARS")]), _vm._v(". And I told myself, All right, so here is this neighborhood geezer who has innocently come outdoors for the nice fresh air; so what of it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally I answered him with a question of my own: “How do you know I’m a cop?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned to somebody standing beside him. Only there was nobody there, of course. “This one, he says, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How’d y’know?’")]), _vm._v(" Can you beat it?” he said to Nobody.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then to me he said, “Friendly, if you want, I can take you to the beach and if there’s a cop there I can pick him out, easy’s pie. Even if he was wearing one of them bathing suits with little sailboats on the bum, I could make him as a cop from everybody else laying around in the sand half bareassed. How is this? Because of the fact that I have a very great power of observation is how, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("He smiled. “Haw! If you could just get a load of your own puss right now, you’d see cop written all over it, same as I” see.”")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“How so?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, for one thing, you’d see yourself looking me over like some high-flying buzzard looks for blood down on the snow. The way you’re looking at me now, you got to be either a dopey little kid or a cop. And it’s kind of hard for me to figure you were ever cute enough to have been a little kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s another thing that tells me you’re a cop. You’re listening close. A cop, he’ll listen to anybody no matter if he’s nothing but a slobbering drunk or a strung-out junkie or a Jesus-jumping loon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re supposed to listen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I ain’t saying you’re not. I am only saying this is what I have observed, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Also I observed by your hands how you’re a cop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My hands?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t take this wrong, friendly, but even somebody who does not have my power of observation can see that you’re a guy who is the lunch-bucket type. But, you have got no callouses on your hands, which from experience says to me you’re a cop, since cops are guys who gravitate into the department because they are mainly lunch-bucket types such as yourself who don’t want to actually do any manual labor on the job. Now, ain’t that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe,” I said. Too true, I thought. I said, “So it’s nothing for you to make any cop in town?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s relatively pretty much of a snap, yeah. Except for your lady cops. They’re trickier since they’re females. But give me the time and I can mostly make them, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see …”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("“Of course you do. Like I said, I got a great power. Besides which, I have been watching you in case you didn’t know …” ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Watching me? “No, I didn’t know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So now you know.” He shrugged. “Anyhow, I made you for a cop from day one. And you are now telling me how right I was. Ain’t that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He did not wait for my answer. Instead, he turned to Nobody next to him, and said, “Damn straight I’m right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then he folded the tabloid that dangled from his hand. He stuffed the paper into the side pocket of this thrift-shop jacket, which was a cream-colored linen number that might have been good in its day. He fished out a lacquer-paper packet of skinny cheroots from the other pocket and put one of them between his lips and offered me one, too. We lit up, then we both turned our heads to watch the Tenth Avenue traffic roll along uptown. Neither of us said a word for about a minute. He had his thoughts, I had mine.")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("In a city unsubtle in all other moods, this geezer here talking to me and to Nobody was one of the true heralds of spring in New York. In most other places during the month of April, you can suddenly see lots of ladies in housedresses hanging out laundry in the sweet new winds, and robins digging up fat worms from wet grass and fragrant mud. In New York, you can be certain that winter has died when you see girls in schoolyards jumping rope double Dutch; when you see how every third guy in a business suit is wearing a yellow necktie; when clusters of people with apprehension in their fair-skinned faces are walking around midtown Manhattan with street maps growing out of their back pockets; and when neighborhood parks see the return of old coots who sit in wait of someone to talk to after the long and lonesome winter indoors. It is spring when they will tell strangers—even cop strangers—the disquieting stories of their lives, and what they have spent the winter thinking about….")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent2"
  }, [_vm._v("“So I was wondering, by the by,” he said, exhaling pungent blue smoke, “if you dress like that all the time or else if this here’s your day off, or what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You might say both.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was wearing chinos with holes in the knees and about ten years’ worth of paint stains, a green tee-shirt from a Hoboken exterminating company that had a picture of a dead cockroach on the chest, a poplin jacket without much collar or cuffs left to it, a Yankees baseball cap, and black high-top P-F Flyer sneakers I have owned since about the last of the Miss Rheingolds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I get it,” he said. “You’re plainclothes. Like maybe an undercover detective, hey? I like detective stories. Maybe I seen something about you in the newspapers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “Not in that paper in your jacket pocket.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He poked an elbow into Nobody’s ribs and said to him, “Here we have an officer with a sense of humor, hey? I like that in a cop. When cops can crack a smile, the city’s less jumpy. Ain’t I right? Damn straight I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then to me, “Well, I read all types of papers, friendly. All the way from your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(" down to this bugle in my pocket, which I can tell you is very often no weirder than stories they put in your polite press. This is on account of the fact that I have observed how everybody is pretty much equally depraved nowadays.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stuck out a soft pink hand and added, with a neighborly sort of smile, “Well, anyhow, I am pleased to finally meet up with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We shook and he said, “I bet you don’t know who I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said he would win that wager.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, don’t worry, it ain’t your fault you don’t know me,” he said. “I ain’t made much of a mark in this life.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("He finished his cheroot and tossed the butt down into the walkway where it would eventually burn out. I thought about telling him how it has been my observation that a lot ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v(" of people in the world wind up tossed to the ground as casually as he had just dropped his cheroot. But I kept my own thoughts quiet in order to concentrate on his, which he had already observed is the obvious nature of a cop like me.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He sat down next to me on the bench and took a handkerchief from his coat pocket and, slipping off his beret, mopped sweat off a full head of skin. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I knew he was bald!")]), _vm._v(" He asked, “Care to know my name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shrugged an assent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everybody who knows me, or thinks he knows me, calls me Picasso. Care to know how come?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I naturally answered, “Because you’re a painter?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which was exactly what he had anticipated my saying, and which was why he sneered at me right as the words slid stupidly from my mouth. After which he turned to Nobody, who had presumably joined us on the bench, and said, “This one, he says, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Because you’re a painter?’")]), _vm._v(" Can you beat it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put his beret back on his head and pocketed the dampened handkerchief. Then he lit up another one of his skinny cheroots, but did not offer me one this time. He sat puffing silently, and gazing out toward the avenue. Then he said, “Come on over with me, you’ll see something about me and the art world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I followed him up from the bench, leaving behind my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times")]), _vm._v(" and my half-eaten roll and most of my coffee. We walked to the bus stop sign on the avenue. He pointed to the other side and said, “See over there across the way in the bodega window where it says’special today, pork two-nineteen a pound’ and there’s a picture of a big fat pig that looks scared out of his gourd?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw it, I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well you’re looking at a genuine Picasso. I bet you never knew that Picasso dabbled in the medium of calcimine paint, hey?” He laughed hard at this. It was one of the sorriest, nastiest laughs I had ever heard.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("“I paint up the Puerto Rican’s windows over there ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v(" regular,” he explained, “in return for which instead of putting out actual money he keeps me in these good smokes and wine that ain’t good at all, and sandwiches. And this is mainly how I now have the artistic thrill of being a painter these days.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, I wish you would cross over there to the bodega sometime before next week’s special—so you can see up close how I captured the essential terror of the doomed pig. Like I said, I am a great one for studying the essence of things. You know, like I have been studying you all these months—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Traffic noise interrupted. Picasso stopped talking and stared at the bodega window through the passing cars and trucks and vans and taxicabs. A Mercury convertible with Jersey plates and front and back seats full of raucous teenage girls out cutting classes waved at the ill-clad guys standing around a bus stop, which is one of the main activities of teenage motorists from Jersey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at Picasso looking at his rendering of the doomed pig and I said to myself, You can let all this wormy stuff go; you have all sorts of other things to do; it is the first day of your well-earned furlough; you recently made the acquaintance of one Ruby Flagg, and she is very gorgeous, and it is the spring of the year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, as if I cannot get enough of this sort of thing, I waited for the traffic to break and asked him some more about himself: “What do you do for actual money?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“As little as possible since I am saving myself for my art!” He laughed another one of his malignant laughs. “Lucky for me, though, I am a resourceful old bastard and get by.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“Sometimes I will return bottles and cans for deposit. Sometimes passing out palm cards for this topless joint over on Seventh Avenue, the Horny Poodle. Sometimes this and sometimes that. You know how it goes in this fine service economy of ours.” ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you live around here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He waved an arm, taking in a large part of the neighborhood. “Around here, around there. You know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about medical?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sneered again and said, “By that, your meaning is what? I’m ready for the drooling academy? People call me Picasso and so you go figuring that I need my head shrunk, is that it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What I mean is …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aw, save it! Let me tell you this: you’re sent to the puzzle house nowadays on account of one basic reason, which is you went and did something so bad that it ain’t acceptably nuts, it’s barking nuts—if you see the difference. Then one day …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stopped and took in a deep, rasping breath. Then he went on. “One day, they just suddenly put you out and wish you all the best. That’s all they know how to do once they finally admit they ain’t got the answers, only questions. The streets are full of us. You think maybe I’m wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think you’re right,” I said. When another clump of noisy traffic had passed, I asked, “How come you’ve been shadowing me? And how come you want to tell me all this that you’re telling me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He said to Nobody, “Now he wants to know ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how come?’! ")]), _vm._v("This one’s maybe the last bleeding heart left in a bloody old heartless city, hey? Can you beat it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked down the avenue. The M-11 bus was idling down at the light over Forty-second Street. It would be up at the park stop in a few minutes. He dug around in his pants pockets for coins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then he turned to me and calmly inquired, “You know from extenuating circumstances, am I right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said he was.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Of course you do. You’re a cop. So maybe I wanted somebody to know about me and my ‘extenuating circumstances.’ Which even a nutso has got. And I am a genuine ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v(" regulation nutso since I have been checking in and out of Bellevue since somewheres during Ike’s second term, okay?”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But Bellevue, see, it’s no use to me. The doctors are right guys and all, but they’re still only ignorant doctors who can only see maybe two sides to a story. Real stories with real people in them have got lots more than two sides, you ever notice?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have noticed that real stories are full of extenuating circumstances,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiled and said, “Yah” because my remark pleased him. For a change, the smile was pleasant. And then he became hurried and counted out coins in his hand, enough for bus fare. The M-11 was now a block away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So since you’re interested,” he said, “I will tell you that once-upon-a-time I was another kind of regulation guy, with a wife and a kid. But as a husband and a papa, I was a lousy flop. The family wasn’t so much better. The wife, she went rotten; the kid went Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, but hell, family life and all that apple pie, it ain’t my game. When I figured this out, I took off to New York. Which is where us odd socks belong. In a manner of speaking, I ran away to join the circus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laughed at this. One of his joyless barks it was. “Yah, that’s rich!” he said. “The circus!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you ever get to paint what you wanted to paint? I mean, did you ever paint seriously?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He said to Nobody, “Ho, ho, did I paint or did I paint? Was I serious or was I serious? And, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how come")]), _vm._v(" did I paint what I painted?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To me, he said, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Serious")]), _vm._v(" paintings? Them I got loads of hanging around town. Here and there, like me; not so anybody should notice, also like me. Which is how come it’s such a big goddamn joke they call me Picasso, hey?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("He added, “Matter of fact, friendly, guess where I got one painting hanging as we speak?” ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In a bar where you yourself hang out regular …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bus groaned to a stop in front of us, killing my last chance to ask Picasso exactly how long he had been watching me. And exactly why.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Picasso stepped aboard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then—just before the pleated doors closed behind him, before he walked to the rear of the bus and sat down, and laughed and laughed at me through the broad back window as I stood there on Tenth Avenue staring at him like a dopey cop—he said:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("“Yah—and since you’re interested—maybe you want to know that I am very sick to death of all the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how comes")]), _vm._v(" of my busted-up life. Which is how come I am working a plan, a plan to kill what’s been responsible for making me fall so far and spectacular as you seen I have fell …” ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1029d7dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter01.vue
// module id = 81
// module chunks = 0